<div class="form-content-item help-page">
  <div class="help-header">
    <div class="help-header-content">
      <div class="help-header-icon">
        <mat-icon>help_outline</mat-icon>
      </div>
      <div>
        <h1>{{ 'help_title' | translate }}</h1>
        <p class="help-header-desc">{{ 'help_faq_subtitle' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="faq-container">
    <mat-accordion class="faq-categories" multi>
      <mat-expansion-panel *ngFor="let section of faqSections; let idx = index" class="faq-category-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="category-number">{{ idx + 1 }}</span>
            <span class="category-label">{{ section.titleKey | translate }}</span>
          </mat-panel-title>
          <mat-panel-description>
            <span class="question-count">{{ section.count.length }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="faq-questions-list">
          <mat-accordion multi>
            <mat-expansion-panel *ngFor="let i of section.count" class="faq-question-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ 'help_faq_' + section.sectionKey + '_q' + i | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="faq-answer">
                {{ 'help_faq_' + section.sectionKey + '_a' + i | translate }}
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="contact-container">
    <h3 class="title-margin-top section-title">{{ 'help_contact_subtitle' | translate }}</h3>
    <mat-card class="contact-card">
      <form class="contact-form" #helpForm="ngForm" (ngSubmit)="onSubmit(helpForm)">
        <div class="contact-grid">
          <div class="contact-fields">
            <div class="form-row">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'help_contact_name' | translate }}</mat-label>
                <input matInput [(ngModel)]="contactForm.name" name="name" required />
                <mat-icon matPrefix>person_outline</mat-icon>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>{{ 'help_contact_email' | translate }}</mat-label>
                <input matInput [(ngModel)]="contactForm.email" name="email" type="email" required />
                <mat-icon matPrefix>mail_outline</mat-icon>
              </mat-form-field>
            </div>
            <mat-form-field appearance="fill">
              <mat-label>{{ 'help_contact_subject' | translate }}</mat-label>
              <input matInput [(ngModel)]="contactForm.subject" name="subject" required />
              <mat-icon matPrefix>subject</mat-icon>
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>{{ 'help_contact_message' | translate }}</mat-label>
              <textarea matInput [(ngModel)]="contactForm.message" name="message" rows="6" required></textarea>
            </mat-form-field>
            <div class="contact-actions">
              <button mat-raised-button color="accent" type="submit" [disabled]="helpForm.invalid">
                <mat-icon>send</mat-icon>
                {{ 'help_contact_send' | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-card>
  </div>
</div>
